import React from "react";
import useStartReveal from "../start/useStartReveal";
import StartShapes from "../start/StartShapes";
import { FOR_SPECS, fill } from "../../data/forPageContent";
import "./ForPage.css";

/** Profession sub-specialization cards (data: LANDING_PAGES[x].specializations). */
export default function ForSpecializations({ pageData }) {
  const ref = useStartReveal();
  const items = pageData?.specializations || [];
  if (items.length === 0) return null;

  return (
    <section id="for-specs" className="st-section fr-specs st-light-shapes" aria-labelledby="fr-specs-title">
      <StartShapes prefix="st-steps" kinds={["ring", "dot", "square"]} />
      <div className="st-container st-reveal" ref={ref}>
        <p className="st-overline st-center">{FOR_SPECS.overline}</p>
        <h2 id="fr-specs-title" className="st-h2 st-center">{fill(FOR_SPECS.title, pageData)}</h2>
        <p className="st-sub st-center fr-section-sub">{FOR_SPECS.sub}</p>
        <ul className="fr-specs-grid" aria-label={fill(FOR_SPECS.title, pageData)}>
          {items.map((s) => (
            <li key={s.name} className="fr-spec">
              <h3 className="fr-spec-name">{s.name}</h3>
              <p className="fr-spec-desc">{s.desc}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
